import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { showCreateEditModal, showCredentialDetail } from 'store/Credentials/actions';
import { Edit } from '../../styled';
import Button from 'shared/ui/Button';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectCredentialsSelected } from 'store/Credentials/selectors';

const EditButton = ({ rowInfo }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showWarning, setShowWarning] = useState(false);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const credentialInVuln = get(rowInfo, 'original', {});
  const id = get(rowInfo, 'original.id', '');
  const message = intl.formatMessage(
    { id: 'modalWarning.selectOnlyOne' },
    { entity: 'Credential' }
  );
  const edit = intl.formatMessage({
    id: 'credentials.modalCreateEdit.editTitle'
  });

  const handleClick = () => {
    if (credentialsSelected.length === 1) dispatch(showCredentialDetail(true, get(credentialsSelected, '[0].value.workspace_name'), get(credentialsSelected, '[0].value.id')));
    else if (id) dispatch(showCreateEditModal(true, credentialInVuln));
    else setShowWarning(true);
  };

  const onClose = () => setShowWarning(false);
  return (
    <>
      <Button variant="ghost" startIcon={ <Edit /> } title={ edit } ariaLabel={ edit } onClick={ handleClick } />
      {showWarning && (
        <ModalWarning
          onCloseCallback={ onClose }
          title="Edit Credential"
          description={ message }
        />
      )}
    </>
  );
};

export default EditButton;
